import { ContentSaveIcon } from './ContentSaveIcon';

/**
 * author: Google
 * id 29F946C0-CA58-4287-AF0B-964961E5CC2C
 * name content-save
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save.svg
 * tags
 */
export const FloppyDiskIcon = ContentSaveIcon;
export default FloppyDiskIcon